import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import Layout from "../../components/Wrappers/Layout";
import { useHistory } from "react-router-dom";
import BackButton from "../../components/BackButton/BackButton";
import FileBase64 from "../../components/Upload/UploadFile";
import Util from "../../validation";
import { countries } from "../../utils/countriesDropdown";
import SaveIcon from "@mui/icons-material/Save";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { dealerAddUpdateDivisonList } from "../../redux/actions/dealerAddUpdateDivisionListAction";
import { dealerAddUpdateDistrictList } from "../../redux/actions/dealerAddUpdateDistrictListAction";
import { dealerAddUpdateThanaList } from "../../redux/actions/dealerAddUpdateThanaListAction";
import { dealerAddUpdateUnionList } from "../../redux/actions/dealerAddUpdateUnionListAction";
import { dealerAddOrUpdateDsrList } from "../../redux/actions/dealerAddOrUpdateDsrListAction";
import { dealerGetDefaultCurrencyListDealer } from "../../redux/actions/dealerGetDefaultCurrencyListDealerAction";
import { getDefaultCurrencyList } from "../../redux/actions/adminCurrencyListAction";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PhoneInput from "react-phone-input-2";
// import val from "../../../../getThemeDetails";
import val from '../../../src/getThemeDetails'
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	InputAdornment,
	IconButton,
} from "@mui/material";
import { Card, FormGroup, Alert, Col } from "reactstrap";
import { IoMdSend } from "react-icons/io";
import SOLogout from "../../components/Logout/SOLogout";
import { FormControl } from "@mui/material";

const DealerAddNewUser = () => {
	// const [mobNumber, setMobNumber] = useState("")
	const [contact, setContact] = useState("")
	console.log(contact, "contact")
	const [getPassword, setGetPassword] = useState("");
	const [getConfirmPassword, setGetConfirmPassword] = useState("");
	const [getRole, setGetRole] = useState("");
	const [getFullName, setGetFullName] = useState("");
	const [getFirstName, setGetFirstName] = useState("");
	const [getLastName, setGetLastName] = useState("");
	const [getMotherName, setGetMotherName] = useState("");
	const [getId, setGetId] = useState("");
	const [getIdNumber, setGetIdNumber] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [getAddress, setGetAddress] = useState("");
	const [editCountry, setEditCountry] = useState("Bangladesh");
	const [editDivision, setEditDivision] = useState("");
	const [editDistrict, setEditDistrict] = useState("");
	const [editThana, setEditThana] = useState("");
	const [editUnion, setEditUnion] = useState("");
	const [customerID, setCustomerID] = useState("")
	const [getPhoneNo, setGetPhoneNo] = useState("")
	const [getCountryCode, setGetCountryCode] = useState("")
	const [getFatherName, setGetFatherName] = useState("")

	const [hiddenPassword, setHiddenPassword] = useState("true");
	const [hiddenConPassword, setHiddenConPassword] = useState("true");

	const [selectedToDate, setSelectedToDate] = useState(new Date());
	// const [getDivisionList, setGetDivisionList] = useState("")

	const [setAddUpdateDivisionListStatus, setSetAddUpdateDivisionListStatus] = useState(false);
	const [setAddUpdateDivisionListArray, setSetAddUpdateDivisionListArray] = useState([]);

	const [setAddUpdateDistrictListStatus, setSetAddUpdateDistrictListStatus] = useState(false);
	const [setAddUpdateDistrictListArray, setSetAddUpdateDistrictListArray] = useState([]);


	const [setAddUpdateThanaListStatus, setSetAddUpdateThanaListStatus] = useState(false);
	const [setAddUpdateThanaListArray, setSetAddUpdateThanaListArray] = useState([]);



	const [setAddUpdateUnionListStatus, setSetAddUpdateUnionListStatus] = useState(false);
	const [setAddUpdateUnionListArray, setSetAddUpdateUnionListArray] = useState([]);

	const [addNewUserDsrListResArray, setAddNewUserDsrListResArray] =
		useState("");
	const [addNewUserDsrListStatus, setAddNewUserDsrListStatus] =
		useState(false);

	const [getDealerDefaultCurrenctListStatus, setGetDealerDefaultCurrenctListStatus] =
		useState(false);
	const [setDealerGetDefaultCurrencyListArray, setSetDealerGetDefaultCurrencyListArray] = useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	// const [getDistrictList, setGetDistrictList] = useState("")
	// const [selectedDivision, setSelectedDivision] = useState("");
	// const [selectedDistrict, setSelectedDistrict] = useState(null)
	const [selectedDivision, setSelectedDivision] = useState()
	const [selectedDistrict, setSelectedDistrict] = useState()
	const [nidFronts, setNidFronts] = useState("");
	const [nidFrontsName, setNidFrontsName] = useState("");

	const [nidBacks, setNidBacks] = useState("");
	const [nidBacksName, setNidBacksName] = useState("");

	const [uploadPhoto, setUploadPhoto] = useState("");
	const [uploadPhotoName, setUploadPhotoName] = useState("");



	const togglePassword = (e) => {
		e.preventDefault();
		setHiddenPassword((state) => !state);
	};

	const toggleConPassword = (e) => {
		e.preventDefault();
		setHiddenConPassword((state) => !state);
	};

	const handleChange = ({ target: { name, value } }) => {
		// if (name === "EditMobNumber") {
		// 	Util.verifyMobile(value)
		// 		? setMobNumber(value)
		// 		: setMobNumber(mobNumber);

		// }
		if (name === "EditPassword") {
			setGetPassword(value)

		}
		if (name === "GetConfirmPassword") {
			setGetConfirmPassword(value)
		}

		if (name === "Role") {
			setGetRole(value)
		}
		if (name === "FullName") {
			Util.verifyAlphabet(value)
				? setGetFullName(value)
				: setGetFullName(getFullName)
		}
		if (name === "FirstName") {
			Util.verifyAlphabet(value)
				? setGetFirstName(value)
				: setGetFirstName(getFirstName)
		}
		if (name === "LastName") {
			Util.verifyAlphabet(value)
				? setGetLastName(value)
				: setGetLastName(getLastName)
		}
		if (name === "MotherName") {
			Util.verifyAlphabet(value)
				? setGetMotherName(value)
				: setGetMotherName(getMotherName)
		}
		if (name === "FatherName") {
			Util.verifyAlphabet(value)
				? setGetFatherName(value)
				: setGetFatherName(getFatherName)
		}
		if (name === "IDType") {
			Util.verifyAlphabet(value)
				? setGetId(value)
				: setGetId(getId)
		}
		if (name === "IDNumber") {
			Util.verifyMobile(value)
				? setGetIdNumber(value)
				: setGetIdNumber(getIdNumber)
		}

		if (name === "EditCurrency") {
			// setCurrency(value);
			setEditCurrency(value);
			// setEditCurrency(value == "Select Currency" ? "" : value);
		}
		if (name === "GetAddress") {
			Util.alphaNumeric(value)
				? setGetAddress(value)
				: setGetAddress(getAddress)
		}
		if (name === "EditCountry") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditCountry(value);
		}
		if (name === "EditDivision") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditDivision(value == "Select Division" ? "" : value);
		}
		if (name === "EditDistrict") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditDistrict(value == "Select District" ? "" : value);
		}
		if (name === "EditThana") {

			setEditThana(value == "Select Thana" ? "" : value);
		}
		if (name === "EditUnion") {

			setEditUnion(value == "Select Union" ? "" : value);
		}


	}
	const handleContact = (value, { dialCode, name, countryCode }) => {
		//console.log(value, dialCode, name, countryCode.toUpperCase())
		console.log(dialCode, "//////dial code")
		setContact(() => ({
			// ...state,
			phone: value,
			countryCode: dialCode,
			//country: name,
			country: countryCode,

		}));
	};
	const [user, setUser] = useState({
		mobileNumber: "",
		password: "",
		confirmPassword: "",
		role: "dsr",
		fullName: "",
		motherName: "",
		fatherName: "",
		photo: "",
		idType: "",
		idNumber: "",
		nidFront: "",
		nidBack: "",
		currency: "",
		address: "",
		country: "",
		division: "",
		district: "",
		thanaUpazilla: "",
		unionWard: ""
	})
	const {
		mobileNumber,
		password,
		confirmPassword,
		role,
		fullName,
		motherName,
		fatherName,
		photo,
		idType,
		idNumber,
		nidFront,
		nidBack,
		currency,
		address,
		country,
		division,
		district,
		thanaUpazilla,
		unionWard
	} = user;
	// const available = data.list.find((c) => c.name === selectedCountry);


	// const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();

	const handleAttachmentsDoc = (e, nidFronts) => {
		if (nidFronts == "nidFronts") {
			setNidFronts(e.base64);
			setNidFrontsName(e.name);
		} else if (nidFronts == "nidBacks") {
			setNidBacks(e.base64);
			setNidBacksName(e.name);
		} else if (nidFronts == "uploadPhoto") {
			setUploadPhoto(e.base64);
			setUploadPhotoName(e.name);
		}
	};
	const partnerloginUser = useSelector(({ login }) => login);
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;


	const setAddOrUpdateDsrList = useSelector(
		({ dealerAddOrUpdateDsrLists }) => dealerAddOrUpdateDsrLists
	)
	const setDivisionList = useSelector(
		({ dealerAddUpdateDivisionLists }) => dealerAddUpdateDivisionLists
	)

	const setDistrictList = useSelector(
		({ dealerAddUpdateDistrictLists }) => dealerAddUpdateDistrictLists
	)

	const setThanaList = useSelector(
		({ dealerAddUpdateThanaLists }) => dealerAddUpdateThanaLists
	)

	const setUnionList = useSelector(
		({ dealerAddUpdateUnionLists }) => dealerAddUpdateUnionLists
	)

	// const dealerGetDefaultCurrencyList = useSelector(
	//     ({ dealerGetDefaultCurrencyLists }) => dealerGetDefaultCurrencyLists
	// );

	// const GetDealerDefaultCurrencyListFunc = () => {
	//     if (getDealerDefaultCurrenctListStatus) {
	//         if (dealerGetDefaultCurrencyList.data.status == "success") {
	//             setSetDealerGetDefaultCurrencyListArray(dealerGetDefaultCurrencyList.data);
	//         }
	//         if (dealerGetDefaultCurrencyList.data.status == "failed") {
	//             setSetDealerGetDefaultCurrencyListArray(dealerGetDefaultCurrencyList.data);
	//         }
	//     }
	// };

	// const setGetDealerDefaultCurrencyListReq = () => {

	//     setGetDealerDefaultCurrenctListStatus(true)
	//     const req = {
	//         loginDetails: {
	//             walletOwnerId: regenerateTokenRes.data.partnerId || "",
	//         },
	//     }
	//     dispatch(dealerGetDefaultCurrencyListDealer(req, authToken))
	// }

	// useEffect(() => {
	//     GetDealerDefaultCurrencyListFunc();
	// }, [dealerGetDefaultCurrencyList.data.status]);

	// useEffect(() => {
	//     setGetDealerDefaultCurrencyListReq()
	// }, [])

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		history.push('/index/dsrMaster')
	};
	const addUserDsrListFunc = () => {
		setAddNewUserDsrListStatus(true);
		const Req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				password: getPassword,
				custId: "",
				fullName: getFullName,
				firstName: getFirstName,
				lastName: getLastName,
				address: getAddress,
				phoneNo: contact.phone || "",
				country: editCountry.split("-")[0],
				role: getRole,
				currency: editCurrency,
				countryCode: contact.countryCode || "",
				// countryCode: getCountryCode,
				division: editDivision,
				district: editDistrict,
				thana: editThana,
				union: editUnion,
				fatherName: getFatherName,
				motherName: getMotherName,
				photoIdType: getId,
				photoIdNumber: getIdNumber,
				profilePic: uploadPhoto.split(",")[1] || "-",

				uploadNIDFront: nidFronts.split(",")[1] || "-",
				uploadNIDBack: nidBacks.split(",")[1] || "-",
				// profilePic: "",
				// uploadNIDFront: "",
				// uploadNIDBack: "",
			}

		}
		return dispatch(dealerAddOrUpdateDsrList(Req, authToken))
		// console.log("addData", Req)

	}

	const AddNewUserDsrListResFunc = () => {
		if (addNewUserDsrListStatus) {
			if (setAddOrUpdateDsrList.data.status == "success") {
				setAddNewUserDsrListResArray(setAddOrUpdateDsrList.data);
				setNotificationOpen(true);
			}
			if (setAddOrUpdateDsrList.data.status == "failed") {
				setAddNewUserDsrListResArray(setAddOrUpdateDsrList.data);
				setNotificationOpen(true);
				//NotificationPopups("error", "Failed", addNewWithdrawLimitRes.data.description);
			}
			if (setAddOrUpdateDsrList.data.status == "Failed") {
				setAddNewUserDsrListResArray(setAddOrUpdateDsrList.data);
				setNotificationOpen(true);
				//NotificationPopups("error", "Failed", addNewWithdrawLimitRes.data.description);
			}
		}
	}

	useEffect(() => {
		if (addNewUserDsrListStatus) {
			AddNewUserDsrListResFunc()
		}
	}, [setAddOrUpdateDsrList.data.status])





	const setAddUpdateDivisionListReq = () => {

		setSetAddUpdateDivisionListStatus(true)
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",


			}
		}
		dispatch(dealerAddUpdateDivisonList(req, authToken))
	}
	const AddUpdateDivisionListFunc = () => {
		if (setAddUpdateDivisionListStatus) {
			if (setDivisionList.data.status == "success") {
				setSetAddUpdateDivisionListArray(setDivisionList.data.list);
			}
			if (setDivisionList.data.status == "failed") {
				setSetAddUpdateDivisionListArray(setDivisionList.data);
			}
		}
	};

	useEffect(() => {
		AddUpdateDivisionListFunc();
	}, [setDivisionList.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {

			setAddUpdateDivisionListReq()

		}
	}, [regenerateTokenRes.data.status])

	// useEffect(() => {
	// 	setAddUpdateDivisionListReq()
	// }, [])



	const setAddUpdateDistrictListReq = () => {

		setSetAddUpdateDistrictListStatus(true)
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				district: editDivision

			}
		}
		dispatch(dealerAddUpdateDistrictList(req, authToken))
	}

	const AddUpdateDistrictListFunc = () => {
		if (setAddUpdateDistrictListStatus) {
			if (setDistrictList.data.status == "success") {
				setSetAddUpdateDistrictListArray(setDistrictList.data.list);
			}
			if (setDistrictList.data.status == "failed") {
				setSetAddUpdateDistrictListArray(setDistrictList.data);
			}
		}
	};
	useEffect(() => {
		if (editDivision) {
			setAddUpdateDistrictListReq()
		}
	}, [editDivision])

	// useEffect(() => {
	// 	setAddUpdateDistrictListReq()
	// }, [editDivision])

	useEffect(() => {
		AddUpdateDistrictListFunc()
	}, [setDistrictList.data.status])


	// useEffect(() => {
	//     // setAddUpdateDistrictListReq()
	// }, [])

	const setAddUpdateThanaListReq = () => {

		setSetAddUpdateThanaListStatus(true)
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				district: editDistrict

			}
		}
		dispatch(dealerAddUpdateThanaList(req, authToken))
	}

	const AddUpdateThanaListFunc = () => {
		if (setAddUpdateThanaListStatus) {
			if (setThanaList.data.status == "success") {
				setSetAddUpdateThanaListArray(setThanaList.data.list);
			}
			if (setThanaList.data.status == "failed") {
				setSetAddUpdateThanaListArray(setThanaList.data);
			}
		}
	};
	useEffect(() => {
		if (editDistrict) {
			setAddUpdateThanaListReq()
		}
	}, [editDistrict])
	// useEffect(() => {
	// 	setAddUpdateThanaListReq()
	// }, [editDivision])

	useEffect(() => {
		AddUpdateThanaListFunc();
	}, [setThanaList.data.status]);




	const setAddUpdateUnionListReq = () => {

		setSetAddUpdateUnionListStatus(true)
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				district: editDistrict,
				thana: editThana

			}
		}
		dispatch(dealerAddUpdateUnionList(req, authToken))
	}

	const AddUpdateUnionListFunc = () => {
		if (setAddUpdateUnionListStatus) {
			if (setUnionList.data.status == "success") {
				setSetAddUpdateUnionListArray(setUnionList.data.list);
			}
			if (setUnionList.data.status == "failed") {
				setSetAddUpdateUnionListArray(setUnionList.data);
			}
		}
	};
	// useEffect(() => {
	// 	setAddUpdateUnionListReq()
	// }, [editDivision, editThana])

	useEffect(() => {
		setAddUpdateUnionListReq()
	}, [editDivision, editThana])

	useEffect(() => {
		AddUpdateUnionListFunc();
	}, [setUnionList.data.status]);


	useEffect(() => {
		// if (editCountry === "") {
		// setEditDivision('');
		setEditDistrict('');
		setEditThana('');
		setEditUnion('')
		// }
	}, [editDivision])

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		// console.log(setUser);

		const obj = {
			...user,
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};
	// const handleChange = ({ target: { name, value } }) => {
	//     if (name === "GetDivision") {
	//         setGetDivisionList(value == "Select Divison" ? "" : value);
	//         // setLevel(value);
	//     }
	// }

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}>
							{/* <Button
                // onClick={backClick}
                onClick={LegalE}
                startIcon={<IoIosArrowBack />}
                variant="text"
                color="primary"
              >
                Go Back
              </Button> */}
						</Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<br />
					<Grid container>
						<Grid item lg={12} md={12} sm={12}>
							<h6
								align="center"
								className="text-center themeText"
							// style={{ marginTop: "1.2rem", marginRight: "3rem" }}
							>
								{" "}
								USER INFORMATION
							</h6>
						</Grid>
					</Grid>
					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }} className="addNewUser">
								{" "}
								<FormGroup>
									{/* <FormControl fullWidth>
										<TextField
											required
											helperText="(Please Enter Valid Mobile Number)"
											// type="number"
											size="small"
											color="primary"
											autoFocus={true}
											label="Mobile Number"
											fullWidth={true}
											name="EditMobNumber"
											id="mobileNumber"
											value={mobNumber || ""}
											// onChange={(e) => onInputChange(e, "number")}
											onChange={handleChange}
										/>
									</FormControl> */}
									{/* <FormControl fullWidth> */}

									{/* <Col md={12} sm={12} className="signup-phoneinput"> */}
									<PhoneInput
										autoFormat={true}
										enableSearch={true}
										onChange={handleContact}
										value={contact.phone || ""}
										onlyCountries={val.onlyCountries}
									// style={{ paddingLeft: "45px" }}
									/>
									{/* </Col> */}
									{/* </FormControl> */}

								</FormGroup>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
											type={hiddenPassword ? "password" : "text"}

											size="small"
											color="primary"
											autoFocus={true}
											label="Password"
											fullWidth={true}
											name="EditPassword"
											id="getPassword"
											value={getPassword || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={handleChange}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={togglePassword}
															onMouseDown={togglePassword}
														>
															{hiddenPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Should be same as PASSWORD)"
											type={hiddenConPassword ? "password" : "text"}

											size="small"
											color="primary"
											autoFocus={true}
											label="Confirm Password"
											fullWidth={true}
											name="GetConfirmPassword"
											id="getConfirmPassword"
											value={getConfirmPassword}
											onChange={(e) => handleChange(e)}
											error={
												getPassword &&
													getPassword !== getConfirmPassword &&
													getConfirmPassword ? (
													<p
														className="passwordNotMatch"
														style={{ color: "red" }}
													>
														{"Password did not match"}
													</p>
												) : (
													""
												)
											}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={toggleConPassword}
															onMouseDown={toggleConPassword}
														>
															{hiddenConPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									select
									required
									size="small"
									color="primary"
									autoFocus={true}
									label="Role"
									fullWidth={true}
									name="Role"
									// value={getRole || ""}
									defaultValue={getRole || "Select Role"}
									onChange={handleChange}
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									<MenuItem value="DSR">DSR</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Full Name"
									fullWidth={true}
									name="FullName"
									value={getFullName || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="First Name"
									fullWidth={true}
									name="FirstName"
									value={getFirstName || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Last Name"
									fullWidth={true}
									name="LastName"
									value={getLastName || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Mother Name"
									fullWidth={true}
									name="MotherName"
									value={getMotherName || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Father Name"
									fullWidth={true}
									name="FatherName"
									value={getFatherName || ""}
									onChange={handleChange}

								/>
								{/* </FormControl>
                                </FormGroup> */}
							</div>

							{/* <div style={{ marginTop: "1.5rem" }}>
								<TextField
									select
									required
									size="small"
									color="primary"
									autoFocus={true}
									label="Role"
									fullWidth={true}
									name="Role"
									value={getRole || ""}
									onChange={handleChange}

								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									<MenuItem value="DSR">DSR</MenuItem>
								</TextField>
							</div> */}
							{/* <div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Full Name"
									fullWidth={true}
									name="FullName"
									value={getFullName || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div> */}
							{/* <div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Mother Name"
									fullWidth={true}
									name="MotherName"
									value={getMotherName || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div> */}
							{/* <div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="Father Name"
									fullWidth={true}
									name="FatherName"
									value={getFatherName || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div> */}
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload Profile Pic
								</Typography>
								{/* <input
                                name="photo"
                                value={photo}
                                className="my-2"
                                type="file"
                                placeholder="Browse"
                                onChange={(e) => onInputChange(e)}
                                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard2"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "uploadPhoto")}
									showUploadList={false}
									value={uploadPhotoName}
								/>
								{uploadPhotoName ? uploadPhotoName : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="ID TYPE"
									fullWidth={true}
									name="IDType"
									value={getId || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e)}
								// onChange={(e) => onInputChange(e, "alphabet")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="ID Number"
									fullWidth={true}
									name="IDNumber"
									value={getIdNumber || ""}
									// onChange={(e) => onInputChange(e)}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "number")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload NID Front
								</Typography>
								{/* <input
                                name="nidFront"
                                value={nidFront}
                                className="my-2"
                                type="file"
                                placeholder="Browse"
                                onChange={(e) => onInputChange(e)}
                                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "nidFronts")}
									showUploadList={false}
									value={nidFrontsName}
								/>
								{nidFrontsName ? nidFrontsName : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload NID Back
								</Typography>
								{/* <input
                                    name="nidback"
                                    value={nidBack}
                                    className="my-2"
                                    type="file"
                                    placeholder="Browse"
                                    onChange={(e) => onInputChange(e)}
                                    /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard1"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "nidBacks")}
									showUploadList={false}
									value={nidBacksName}
								/>
								{nidBacksName ? nidBacksName : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									select
									required

									size="small"
									color="primary"
									autoFocus={true}
									label="Currency"
									fullWidth={true}
									name="EditCurrency"
									// value={currency || ""}
									// value={editCurrency || ""}
									onChange={handleChange}
									// onChange={(e) => handleChange}
									// name="currency"
									// // value={currency}
									defaultValue={editCurrency || "Select Currency"}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>
									<MenuItem value="BDT">BDT</MenuItem>

									{/* {dealerGetDefaultCurrencyList.success &&
                                        dealerGetDefaultCurrencyList.data.currencyList.map((x) => (
                                            <MenuItem value={x.name}>{x.name}</MenuItem>
                                        ))} */}
									{/* {adminCurrencyList.success &&
                                        adminCurrencyList.data.currencyList.map((x) => (
                                            <MenuItem value={x}>{x}</MenuItem>
                                        ))} */}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									size="small"
									color="primary"
									autoFocus={true}
									label="Address"
									fullWidth={true}
									name="GetAddress"
									value={getAddress || ""}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e)}
								// onChange={(e) => onInputChange(e, "both")}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Country"
									fullWidth={true}
									name="EditCountry"
									// value={country}
									value={editCountry}
									// defaultValue={editCountry || "Bangladesh"}
									disabled
									// onChange={(e) => onInputChange(e)}
									onChange={handleChange}
								>
									<MenuItem value="" selected="Select Country">
										Select Country
									</MenuItem>
									{countries.map((value) => (
										<MenuItem value={value.label}>
											{value.label}
										</MenuItem>
									))}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Division"
									fullWidth={true}
									name="EditDivision"
									// value={selectedDivision}

									onChange={handleChange}
									value={editDivision || ""}
								// value={country}
								// defaultValue={"Select Divison" || division}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="Select Divison" selected="Select Divison">
										Select Division
									</MenuItem>
									{/* {setDivisionList.success} */}
									{setDivisionList.success &&
										setDivisionList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}
									{/* {countries.map((value) => (
                                        <MenuItem value={value.label + value.dial_code}>
                                            {value.label}
                                        </MenuItem>
                                    ))} */}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="District"
									fullWidth={true}
									name="EditDistrict"
									onChange={handleChange}
									value={editDistrict || ""}
								// value={country}
								// defaultValue={district || "Select District"}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="Select District" selected="Select District">
										Select District
									</MenuItem>
									{setDistrictList.success &&
										setDistrictList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}
									{/* {countries.map((value) => (
                                        <MenuItem value={value.label + value.dial_code}>
                                            {value.label}
                                        </MenuItem>
                                    ))} */}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Thana/Upazilla"
									fullWidth={true}
									name="EditThana"
									onChange={handleChange}
									value={editThana || ""}
								// value={country}
								// defaultValue={thanaUpazilla || "Select Thana/Upazilla"}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem
										value="Select Thana/Upazilla"
										selected="Select Thana/Upazilla"
									>
										Select Thana/Upazilla
									</MenuItem>

									{setThanaList.success &&
										setThanaList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}
									{/* {countries.map((value) => (
                                        <MenuItem value={value.label + value.dial_code}>
                                            {value.label}
                                        </MenuItem>
                                    ))} */}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Union/Ward"
									fullWidth={true}
									name="EditUnion"
									value={editUnion || ""}
									onChange={handleChange}

								// value={country}
								// defaultValue={unionWard || "Select Union/Ward"}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem
										value="Select Union/Ward"
										selected="Select Union/Ward"
									>
										Select Union/Ward
									</MenuItem>
									{setUnionList.success &&
										setUnionList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}
									{/* {countries.map((value) => (
                                        <MenuItem value={value.label + value.dial_code}>
                                            {value.label}
                                        </MenuItem>
                                    ))} */}
								</TextField>
							</div>
							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
                                    style={{
                                        // marginLeft: "0.7rem",
                                        backgroundColor: "#00b9f5",
                                        color: "white",
                                    }}
                                    variant="contained"
                                // color="primary"
                                // onClick={submitClick}
                                // endIcon={<SaveIcon />}
                                >
                                    Submit
                                </Button> */}

								<CustomButton
									style={{
										padding: "8px",
										// marginLeft: "0.7rem",
										margin: "0 8px"
									}}
									variant="contained"
									onClick={addUserDsrListFunc}
								>
									Submit
									<SaveIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
								</CustomButton>
							</div>
						</Grid>
						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>

			{addNewUserDsrListResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewUserDsrListResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewUserDsrListResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewUserDsrListResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewUserDsrListResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewUserDsrListResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewUserDsrListResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewUserDsrListResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default DealerAddNewUser;
